import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { UserPermission } from '@core-lib/enums/user-permission.enum';
import { UserStoreSelectors, UserStoreState } from '@core-lib/store/user-store';
import { Store, select } from '@ngrx/store';
import { getCommonSettingsCarpaRoutePath, getCommonSettingsNaturesAffairesRoutePath, getCommonSettingsParametersCarpaRoutePath, getHomeFullPath, getRechercheAffaireRoutePath, getRegistreBenefEffectifFullPath, getSaisieOperationsRoutePath, getSaisieTraitementOperationsECarpaRoutePath } from 'projects/app-back/src/app/routes-definitions';
import { Observable, filter, first, map } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class PermissionRedirectGuard {

  constructor(private router: Router, private store: Store<UserStoreState.IUserStoreState>) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean>  {
	const menuKey = route.data['menuKey'];
    const routeFn = dynamicRedirectRoutes[menuKey];
    return this.store.pipe(
			select(UserStoreSelectors.selectUserPermissions),
			filter(p => p?.length > 0),
			map(permissions => {
				const target = routeFn?.(permissions) || '/';
				this.router.navigate([target]);
				return false;
			}),
			first()
		);
  }
}


type DynamicRedirectMap = {
	[key: string]: (permissions: UserPermission[]) => string;
  };

export const dynamicRedirectRoutes: DynamicRedirectMap = {
	'common-settings': getDynamicCommonSettingsRoute,
	'saisies': getDynamicSaisieRoute,
	'recherche-consultation': getDynamicRechercheRoute
  };

export function getDynamicCommonSettingsRoute(permissions: UserPermission[]): string {
  if (permissions.includes(UserPermission.ViewAllNaturesAffaire)) return getCommonSettingsNaturesAffairesRoutePath();
  // RG2 : le Super Admin gère toutes les CARPA (pas de carpa courante), il n'atterrit pas sur "Paramètres de ma Carpa"
  if (permissions.includes(UserPermission.ViewCarpa) && !permissions.includes(UserPermission.IsSuperAdmin)) return getCommonSettingsParametersCarpaRoutePath();
  if (permissions.includes(UserPermission.CreateCarpa)) return getCommonSettingsCarpaRoutePath();
  return getHomeFullPath();
}

export function getDynamicSaisieRoute(permissions: UserPermission[]): string {
	if (permissions.includes(UserPermission.CreateAffaire)) return getSaisieOperationsRoutePath();
	if (permissions.includes(UserPermission.ViewOperationsTraitement)) return getSaisieTraitementOperationsECarpaRoutePath();
	return getHomeFullPath();
  }

  export function getDynamicRechercheRoute(permissions: UserPermission[]): string {
	if (permissions.includes(UserPermission.ViewAllOperationsTraitement)) return getRechercheAffaireRoutePath();
	if (permissions.includes(UserPermission.RbeCanview)) return getRegistreBenefEffectifFullPath();
	return getHomeFullPath();
  }